import React from 'react';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import DataPrivacy from '@atlassian/jira-illustrations/src/ui/adg5/jira/spots/other/components/data-privacy/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const styles = cssMap({
	containerStyles: {
		alignItems: 'center',
		gap: token('space.200'),
		maxWidth: '400px',
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		textAlign: 'center',
	},
	textBlockStyles: {
		gap: token('space.100'),
		alignItems: 'center',
	},
});

export const PrivateProjectPopup = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Stack xcss={styles.containerStyles}>
			<DataPrivacy alt={formatMessage(messages.iconLabel)} height={96} width={96} />
			<Stack xcss={styles.textBlockStyles}>
				<Heading size="xsmall">{formatMessage(messages.title)}</Heading>
				<Text color="color.text">{formatMessage(messages.description)}</Text>
			</Stack>
		</Stack>
	);
};
